//TODO : Make scrolling behavior not having to rely on magic numbers.

import { isEmpty } from "lodash";

export const onKSelect = (e, open, toggleOpen, search) => {
    if (e.key === "Enter") {
        e.preventDefault();
        toggleOpen((prev) => !prev);
    } else if ((e.key === "ArrowDown") || (e.key === "ArrowUp")) {
        e.preventDefault();
        if (!open) {
            toggleOpen(true);
        } else {
            if (search) {
                let dd = _getTargetChild(e.target.children, "dropDown") || _getTargetParent(e.target, "dropDown");

                let searchBar = dd.children[0];
                let optionList = dd.children[1].children[0].children[0];
                let codeFooter = dd.children[2];

                if (!optionList) {
                    return;
                }

                const options = _getSelectedOption(optionList.children);

                if (!options) {
                    optionList.children[0].click();
                    toggleOpen(true);
                    return;
                }
                const { selectedOption, index } = options;

                if (e.key === "ArrowDown") {
                    if (optionList.children[index + 1]) {
                        optionList.children[index + 1].click();
                        dd.children[1].children[0].scrollBy(0, 30);
                        toggleOpen(true);
                    }
                }

                if (e.key === "ArrowUp") {
                    if (optionList.children[index - 1]) {
                        optionList.children[index - 1].click();
                        dd.children[1].children[0].scrollBy(0, -30);
                        toggleOpen(true);
                    }
                }
            }
            else {
                let dd = _getTargetChild(e.target.children, "dropDown");
                let optionList = dd.children[0].children[0].children[0];
                const options = _getSelectedOption(optionList.children);

                if (!options) {
                    optionList.children[0].click();
                    toggleOpen(true);
                    return;
                }
                const { selectedOption, index } = options;

                if (e.key === "ArrowDown") {
                    if (optionList.children[index + 1]) {
                        optionList.children[index + 1].click();
                        dd.children[0].children[0].scrollBy(0, 30);
                        toggleOpen(true);
                    }
                }

                if (e.key === "ArrowUp") {
                    if (optionList.children[index - 1]) {
                        optionList.children[index - 1].click();
                        dd.children[0].children[0].scrollBy(0, -30);
                        toggleOpen(true);
                    }
                }
            }
        }
    } else if (e.key === "Tab" && search && isEmpty(e.target.children)) {
        //If tab is pressed and we're dealing with a search drop-down we want to close and deactivate the field after passing the search bar
        toggleOpen(false);
    } else if (e.key === "Tab" && !search) {
        //If tab is pressed we want to close and deactivate the field
        toggleOpen(false);
    }
}

//? Private methods
const _getTargetChild = (children, targetClass) => {
    for (let i = 0; i < children.length; i++) {
        if (children[i].className) {
            if (children[i].className.includes(targetClass)) {
                return children[i];
            }
        }
    }
}

const _getTargetParent = (element, targetClass) => {
    let currentElement = element;
    
    while (currentElement.parentElement && !currentElement.parentElement.className.includes(targetClass)) {
        currentElement = currentElement.parentElement;
    }

    if (currentElement.parentElement) {
        return currentElement.parentElement;
    }
    return null;
}

const _getSelectedOption = (options) => {
    for (let i = 0; i < options.length; i++) {

        if (options[i].className) {
            if (options[i].className.includes("selected")) {
                return {
                    selectedOption: options[i],
                    index: i
                };
            }
        }
    }
}